import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeviceSystemActivityLogComponent } from './device-system-activity-log.component';

const routes: Routes = [
  {
    path: 'device-system-activity-log',
    data: { name: 'Device System Activity Log', isTab: false },
    component: DeviceSystemActivityLogComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceSystemActivityLogPageRoutingModule {}
